module.exports = __webpack_public_path__ + "img/apply-gift-dialog-title.26d9e865.png";